import React, { createContext } from 'react';
import axios from 'axios';

export const AxiosContext = createContext({ instance: axios.create() });
export const AxiosConsumer = AxiosContext.Consumer;

export const AxiosProvider = ({ instance, children }) => (
  <AxiosContext.Provider value={{ instance }}>{children}</AxiosContext.Provider>
);
